module.exports = __webpack_public_path__ + "img/symbol_8.31f23d69.png";